<template>
	<div
		:class="['list-item-wrapper', { 'open': isActive }]"
		v-on="events"
	>
		<img class="savings-icon" :src="meter_icon" svg-inline />
		<span class="savings-label">$</span><AnimatedNumber class="savings-number" :number="balance" />
		<div class="savings-target" v-if="savingsTarget">of ${{ savingsTarget }}</div>
		<Tooltip class="tooltip" :title="title" :info="info" />
	</div>
</template>

<script>
import { thousandsStringFormatter } from "@/lib/formatters";
import Tooltip from "@/components/base/Tooltip";
import AnimatedNumber from "@/components/base/AnimatedNumber";

export default {
	name: 'Savings',
	components: {
		Tooltip,
		AnimatedNumber,
	},
	props: {
		id: {
			type: Number,
			required: true,
		},
		title: {
			type: String,
			required: true,
		},
		meter_icon: {
			type: String,
			required: true,
		},
		info: {
			type: String,
			required: true,
		},
	},
	computed: {
		balance() {
			return this.$store.state.game.funds[this.id].balance;
		},
		savingsTarget() {
			return thousandsStringFormatter(this.$store.state.game.funds[this.id].minimum_winning_balance);
		},
		events() {
			const desktop = window.screen.width >= 1366;
			return {
				...(!desktop && { click: this.toggleOpen }),
				...(desktop && { mouseenter: this.toggleOpen }),
				...(desktop && { mouseleave: this.toggleOpen }),
			};
		},
	},
	data() {
		return {
			isActive: false,
		};
	},
	methods: {
		toggleOpen() {
			this.isActive = !this.isActive;
		},
	},
};
</script>

<style lang="scss" scoped>
	.list-item-wrapper {
		position: relative;

		&.open {
			.tooltip {
				transform: translateX(0);
				box-shadow: $box-shadow;
				opacity: 1;
			}
		}
	}

	.savings-icon {
		width: 100%;
		padding: 3% 25%;

		@include tablet { padding: 20%; }
		@include desktop { padding: 15%; }
		@include desktop-sm { padding: 10% 20%; }
	}

	.savings-target {
		text-transform: none;
		color: $primary-color;
	}

	.tooltip {
		transition: all $ui-transition-duration;
		transform: translateX(-100%);
		opacity: 0;
		z-index: -1;
	}
</style>



// WEBPACK FOOTER //
// src/components/game/sidebar/Savings.vue